import React, { useEffect } from 'react';

interface IAutoSubmitProps {
  values: any;
  isValid: boolean;
  submitForm: () => void;
}

export const AutoSubmit: React.FC<IAutoSubmitProps> = ({ values, isValid, submitForm }) => {
  useEffect(() => {
    if (isValid) {
      submitForm();
    }
  }, [values, submitForm, isValid]);

  return null;
};
